<nav #navbar class="navbar active">
  <div class="container-fluid">
    <div class="navbar-header">
      <a href="#" onClick="return false;" class="navbar-toggle collapsed"
        (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"></a>
      <a href="#" onClick="return false;" class="bars" (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
      <div class="row">
      <a class="navbar-brand rolename" routerLink={{homePage}} >
        <!-- <img src="assets/images/logo.png" alt="" />
        <span class="logo-name">ddddddddddd{{empdetails?.designationName}}</span> -->
        <!-- <img src="assets/images/logo.png" alt="" />
        <span class="logo-name">
          
        </span> -->
        <div class="rolename" >
          <mat-form-field class="example-full-width" appearance="" style="text-align: center; width: 94% !important;">
            <!-- <mat-label>Role Name</mat-label> -->
            <mat-select  [(ngModel)]="asignRoleName" (selectionChange)="onRoleChange($event)">
                <ng-container *ngFor="let rName of viewRole let last = last">
                  <mat-option [value]="rName.roleId" style="min-height: 20px;"> {{ rName.roleName }}</mat-option>
                  <mat-divider *ngIf="!last"></mat-divider>
               </ng-container>
            </mat-select>
          </mat-form-field>

        </div>
        
      </a>
    </div>
    </div>
    <div class="collapse navbar-collapse" [ngClass]="isNavbarCollapsed ? '' : 'show'">
      <ul class="float-start collapse-menu-icon" style="display: flex;">
        <li>
          <button mat-button (click)="callSidemenuCollapse()" class="sidemenu-collapse nav-notification-icons"> <i
              class="material-icons-outlined icon-color">
              menu
            </i></button>
        </li>
        <!-- <li class="countdown_time">
          <span class="timespan">{{ time | date: 'MMM d, y, h:mm:ss a' }}</span>
        </li> -->
      </ul>
      <!-- <ul class="nav navbar-nav">
        <li>
          <span>Time</span>
        </li>
      </ul> -->
    
      <ul class="nav navbar-nav navbar-right" >

        <!-- <li class="fullscreen branch_switch" style="margin-right: 30px; margin-bottom: -19px;"
          *ngIf="detpdata?.length > 1">
          <mat-form-field class="example-full-width" [style.width.px]=160>
            <mat-select [(value)]="departmentId" (selectionChange)="setdept($event.value)">
              <mat-option value="0">All</mat-option>
              <mat-option *ngFor="let d of detpdata" [value]="d.departmentId">{{d.deptName}}</mat-option> 
            </mat-select>
          </mat-form-field>
        </li> -->

       <!-- <mat-form-field class="example-full-width"  [style.width.px]=170 class="mycss">
            <mat-label>Legal Entities</mat-label>
            <mat-select  formControlName="Lentities">
              <mat-option value="Father">Vigyan Bharati Charitable Trust </mat-option>
              <mat-option value="Mother">Vidyasagar Charitable Trust  </mat-option>
              <mat-option value="Sister">Kunjabinodin Charitable Trust  </mat-option>
              <mat-option value="Brother">Hi-Tech Estates & Promoters Pvt. Ltd  </mat-option>
              <mat-option value="Friend">Rajadhani Systems & Estates Pvt. Ltd </mat-option>
              <mat-option value="Relative">Hi-Tech M/s Multiplex Pvt.Ltd </mat-option>
              <mat-option value="Father">Hi-Tech M/s Edifice Pvt.ltd </mat-option>
              <mat-option value="Mother">Hi-Tech Media Network Pvt. Ltd.   </mat-option>
              <mat-option value="Sister">	M/s Konark Habitat Pvt. Ltd.  </mat-option>
              <mat-option value="Brother">M/s Biswa Pharmaceuticals Pvt. Ltd </mat-option>
              <mat-option value="Friend">M/s Mokshya Retails Pvt Ltd  </mat-option>
         
          
           </mat-select>
          </mat-form-field> -->

    <!-- <div *ngIf="roleId != '65' "> -->
      <li class="fullscreen branch_switch" style=" margin-bottom: -19px;" *ngIf="userName !== 'Super Admin'">
  
 
          <mat-form-field class="example-full-width mycss" [style.width.px]=150  appearance="fill" >
            <mat-select  [(ngModel)]="legalEntity" (ngModelChange)="getBusinessArea($event,getLegalEntityName($event))">
              <!-- <mat-option [value]="0" *ngIf="selectLeBaBvBu('legalEntityId')">Select LE</mat-option> -->
              <!-- <mat-option [value]="0" *ngIf="roleId !== '24' && roleId !== '26'">Select LE</mat-option> -->
              <mat-option [value]="0" *ngIf="clientAdminRoleId !== null && clientAdminRoleId !== 'null'">
                Select LE
              </mat-option>
              <mat-option *ngFor="let d of roleData" [value]="d.legalEntityId">{{d.legalEntityName}}</mat-option> 
            </mat-select> 
          </mat-form-field>
        </li>
        
  
        <li class="fullscreen branch_switch" style=" margin-bottom: -19px;" *ngIf="userName !== 'Super Admin'">
  
            <mat-form-field class="example-full-width mycss"  [style.width.px]=150 > 
              <mat-select  [(ngModel)]="businessArea" (ngModelChange)="getBusinessVertical($event)">
                <!-- <mat-option [value]="0" *ngIf="selectLeBaBvBu('locationId')">Select BA</mat-option> -->
                <!-- <mat-option [value]="0" *ngIf="roleId === '24' || roleId === '23'">Select BA</mat-option> -->
                <mat-option [value]="0" *ngIf="(legalEntityAdminRoleId !== null && legalEntityAdminRoleId !== 'null')  || (clientAdminRoleId !== null && clientAdminRoleId !== 'null') ">Select BA</mat-option>


                <mat-option *ngFor="let d of ViewBusinessArea" [value]="d.locationId">{{d.businessareaName}}</mat-option> 
              </mat-select>
            </mat-form-field> 
          </li>
  
          <li class="fullscreen branch_switch" style=" margin-bottom: -19px;" *ngIf="userName !== 'Super Admin'">
  
            <mat-form-field class="example-full-width mycss" [style.width.px]=150 >
              <mat-select   [(ngModel)]="businessVertical" (ngModelChange)="getBusinessUnit($event)">
                <!-- <mat-option [value]="0" *ngIf="selectLeBaBvBu('businessSegmentsId')">Select BV</mat-option> -->
                <mat-option [value]="0" *ngIf="(legalEntityAdminRoleId !== null && legalEntityAdminRoleId !== 'null')  || (clientAdminRoleId !== null && clientAdminRoleId !== 'null') ">Select BV</mat-option>

                <mat-option *ngFor="let d of ViewBusinessVertical" [value]="d.businessSegmentsId">{{d.businessVertical}}</mat-option> 
              </mat-select>
            </mat-form-field> 
          </li>
          <li class="fullscreen branch_switch" style=" margin-bottom: -19px;" *ngIf="userName !== 'Super Admin'">
            <mat-form-field class="example-full-width mycss" [style.width.px]=150>
              <mat-select [(ngModel)]="BusinessUnit1" [(value)]="businessarea" (ngModelChange)="setbarea($event)">
                <!-- <mat-option [value]="0" *ngIf="selectLeBaBvBu('businessAreaId')">Select BU</mat-option> -->
                <mat-option [value]="0" *ngIf="(legalEntityAdminRoleId !== null && legalEntityAdminRoleId !== 'null')  || (clientAdminRoleId !== null && clientAdminRoleId !== 'null') ">Select BU</mat-option>

                <mat-option *ngFor="let bunit of BusinessUnit" [value]="bunit.businessAreaId">{{bunit.aliasName}}</mat-option>
              </mat-select>
            </mat-form-field>
          </li>

  

      <!-- </div> -->

        
        <!-- Full Screen Button -->
        <!-- <li class="fullscreen">
          <button mat-button class="nav-notification-icons" (click)="callFullscreen()"> <i class="material-icons-outlined icon-color"> fullscreen</i></button>
        </li> -->
        <!-- #END# Full Screen Button -->
        <!-- #START# Notifications-->
        <li>
          <button mat-button [matMenuTriggerFor]="notificationMenu" class="nav-notification-icons"> <i  class=" material-icons-outlined icon-color"> notifications_active </i></button>
          <mat-menu #notificationMenu="matMenu" class="nfc-menu" xPosition="before">
            <div class="nfc-header">
              <h5 class="mb-0">Notifications</h5>
              <a class="nfc-mark-as-read">Mark all as read</a>
            </div>
            <div class="nfc-dropdown">
              <ng-scrollbar style="height: 350px" visibility="hover">
                <div class="noti-list header-menu">
                  <div class="menu">
                    <div>
                      <button mat-menu-item *ngFor="let notification of notifications" onClick="return false;"
                        [ngClass]="[notification.status]">
                        <span class="table-img msg-user ">
                          <i class="material-icons-two-tone nfc-type-icon"
                            [ngClass]="[notification.color]">{{notification.icon}}</i>
                        </span>
                        <span class="menu-info">
                          <span class="menu-title">{{notification.message}}</span>
                          <span class="menu-desc mt-2">
                            <i class="material-icons">access_time</i> {{notification.time}}
                          </span>
                        </span>
                        <span class="nfc-close">
                          <app-feather-icons [icon]="'x'" [class]="'user-menu-icons'"></app-feather-icons>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </ng-scrollbar>
            </div>
            <div class="nfc-footer">
              <a class="nfc-read-all">Read
                All Notifications</a>
            </div>
          </mat-menu>
        </li>
        <!-- #END# Notifications-->
        <!-- <li class="nav-item">
          <button mat-button [matMenuTriggerFor]="languagemenu" class="lang-dropdown nav-notification-icons"> <img
              *ngIf="flagvalue !== undefined" src="{{flagvalue}}" height="16">
            <img *ngIf="flagvalue === undefined" src="{{defaultFlag}}" height="16"></button>
          <mat-menu #languagemenu="matMenu" class="lang-item-menu">
            <div *ngFor="let item of listLang" class="lang-item">
              <button mat-menu-item class="dropdown-item lang-item-list"
                (click)="setLanguage(item.text, item.lang, item.flag)"
                [ngClass]="{'active': langStoreValue === item.lang}">
                <img src="{{item.flag}}" class="flag-img" height="12"> <span class="align-middle">{{item.text}}</span>
              </button>
            </div>
          </mat-menu>
        </li> -->
        <li class="nav-item user_profile">
          <button mat-button [matMenuTriggerFor]="profilemenu">
            <div class="chip dropdown-toggle" ngbDropdownToggle class="">
              <span style="color:white">{{fullname}}</span>
              <!-- <img src="{{userImg}}" class="user_img" width="32" height="32" alt="User"> -->
            </div>
          </button>
          <mat-menu #profilemenu="matMenu" class="profile-menu">
            <div class="noti-list">
              <div class="menu ">
                <div class="user_dw_menu">
                  <!-- <button mat-menu-item>
                    <app-feather-icons [icon]="'user'" [class]="'user-menu-icons'"></app-feather-icons>Account
                  </button> -->
                  <!-- <button mat-menu-item routerLink="/admin/dashboard/view-profile">
                    <app-feather-icons [icon]="'eye'" [class]="'user-menu-icons'"></app-feather-icons>View Profile
                  </button> -->
                  <!-- <button mat-menu-item>
                    <app-feather-icons [icon]="'mail'" [class]="'user-menu-icons'"></app-feather-icons>Inbox
                  </button> -->
                  <button mat-menu-item routerLink="/admin/dashboard/change-password">
                    <app-feather-icons [icon]="'settings'" [class]="'user-menu-icons'"></app-feather-icons>Change Password
                  </button>
                  <!-- <button mat-menu-item >
                    <app-feather-icons [icon]="'eye'" [class]="'user-menu-icons'"></app-feather-icons>Change Password
                  </button> -->
                  <button mat-menu-item (click)="logout()">
                    <app-feather-icons [icon]="'log-out'" [class]="'user-menu-icons'"></app-feather-icons>Logout
                  </button>
                </div>
              </div>
            </div>
          </mat-menu>
        </li>
        <!-- #END# Tasks -->
      </ul>
    </div>
    <!-- <nav #navbar class="navbar" style="top: 61px;">
      <div class="container-fluid">
        <div class="navbar-header">
        </div>
        <div class="collapse navbar-collapse" [ngClass]="isNavbarCollapsed ? '' : 'show'" *ngIf="!isNavBarHideShow">
          <div class="block-header">
            <div class="page_title">
                <ul class ="list-items">
                    <li *ngFor="let menu of headerMenuList" class="example-button-row">
                        <button mat-raised-button class="example-add-tab-button msr-2"
                        [routerLink]="[menu.functionURL]" [ngClass]="checkActivelink(menu)"
                             (click)="setPermission(menu.permission,menu.menuLinkId)">
                           {{menu.menuLinkName}}
                        </button>
                    </li>
                </ul>
            </div>
          </div>
        </div>
       
      </div>
    </nav> -->
  </div>
</nav>
